export const MPI_ID_QUERY_PARAM_NAME = 'mpi-id';
